import { render, staticRenderFns } from "./OrganismTheAlerts.vue?vue&type=template&id=7ffe8d72&"
import script from "./OrganismTheAlerts.vue?vue&type=script&lang=js&"
export * from "./OrganismTheAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports